import { render, staticRenderFns } from "./InsightView.vue?vue&type=template&id=6773c52b&scoped=true"
import script from "./InsightView.vue?vue&type=script&lang=js"
export * from "./InsightView.vue?vue&type=script&lang=js"
import style0 from "./InsightView.vue?vue&type=style&index=0&id=6773c52b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773c52b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6773c52b')) {
      api.createRecord('6773c52b', component.options)
    } else {
      api.reload('6773c52b', component.options)
    }
    module.hot.accept("./InsightView.vue?vue&type=template&id=6773c52b&scoped=true", function () {
      api.rerender('6773c52b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Insight/InsightView.vue"
export default component.exports